// Shipping Speeds
export const STANDARD = 'Standard';
export const RUSH = 'Rush';
export const SUPER_RUSH = 'Super Rush';

// Shipping Messages
export const GET_IT_BY = 'Get it by';

export const CONFIG = {
  caveat: false,
  guaranteed: true
};
